import {
  ProductGalleryPrevControl,
  ProductGalleryVariant,
} from '@vs-shop/commerce-ui/productGallery';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../../utils/intl';

type Props = { onPrev: () => void };

/** The lightbox's step back, named in this tenant's language. */
export default function GalleryModalPrevButton({ onPrev }: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  return (
    <ProductGalleryPrevControl
      variant={ProductGalleryVariant.OVERLAY}
      onClick={() => {
        onPrev();
      }}
      aria-label={intl.formatMessage({
        id: 'component.server.page.product.gallery.galleryModalPrevButton.previous',
        defaultMessage: 'Předchozí',
      })}
    />
  );
}
